import React from 'react';
import { Button } from '@spothero/ui';
export const InfoWindowCTA = ({ onClick, checkoutUrl, isToCheckout, }) => {
    return (<Button marginRight={1} asAnchor={isToCheckout} href={isToCheckout ? checkoutUrl : null} data-testid="InfoWindowCTA-button" variant="tertiary" onClick={onClick}>
            {isToCheckout ? 'Book Now' : 'Details'}
        </Button>);
};
